<template>
  <AppHeader>Create Shop Logs</AppHeader>

  <div class="p-4">
    <div class="p-3 bg-white shadow-md rounded-2xl space-y-4">

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Date</p>
        <input class="w-full text-xl bg-gray-100" type="date" v-model="form.visited_date" disabled>
        <p v-if="errors.visited_date" class="text-red-500 text-sm mt-1">{{ errors.visited_date }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Purpose</p>
        <select v-model="form.types" class="w-full text-xl bg-white">
          <option value="">-- Select Purpose --</option>
          <option v-for="(type, index) in types" :key="index" :value="type">{{ type }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.types">{{ errors.types }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600 mb-1">Images</p>
        <input class="w-full" type="file"  multiple accept=".jpg,.jpeg,.png" @change="shopFileUpload">
        <p v-if="errors.images" class="text-red-500 text-sm mt-1">{{ errors.images }}</p>
        <ul v-if="form.images.length" class="mt-2 text-sm text-gray-600">
          <li v-for="(file, i) in form.images" :key="i">{{ file.name }}</li>
        </ul>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Notes</p>
        <textarea class="w-full text-xl outline-none" v-model="form.notes" placeholder="Enter Notes"></textarea>
      </div>

      <div class="mt-5 text-center">
        <button class="px-4 py-2 text-sm text-gray-700 uppercase rounded-full bg-slate-300" @click="storeLog">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/Header.vue';
import mixin from '@/utils/mixin';
import formMixin from '@/utils/mixins/form';
import dayjs from 'dayjs';

export default {
  name: 'ShopLogsCreate',
  mixins: [ mixin, formMixin ],
  components: { AppHeader },

  data() {
    return {
      types: [],
      display: { id: '', name: '' },
      form: {
        visited_date: '',
        types: '',
        images: [],
        notes: ''
      },
      errors: {
        visited_date: '',
        types: '',
        images: ''
      }
    };
  },

  mounted() {
    const dealer = this.$store.state.user || JSON.parse(localStorage.getItem('dealer_user'));
    if (!dealer?.id) return this.$router.push('/');

    this.display.id = dealer.id;
    this.display.name = dealer.name;

    this.form.dealer_id = dealer.id;
    this.display.name = dealer.name;

    this.form.visited_date = dayjs().format('YYYY-MM-DD');
  },

  methods: {
    async shopFileUpload(e) {
      const files = Array.from(e.target.files);
      const max = 1 * 1024 * 1024;
      const total = files.reduce((s, f) => s + f.size, 0);
      const q = total > max ? max / total : 0.8;

      const out = [];
      for (const f of files) {
        if (f.size < 200 * 1024) {
          out.push(f);
          continue;
        }

        const img = await createImageBitmap(f);

        const c = document.createElement('canvas');
        c.width = img.width;
        c.height = img.height;
        c.getContext('2d').drawImage(img,0,0);
        img.close();

        const blob = await new Promise(r => c.toBlob(r, "image/jpeg", q));

        if (blob && blob.size < f.size) {
          out.push(new File([blob], f.name, { type: "image/jpeg" }));
        } else {
          out.push(f);
        }
      }
      
      const finalTotal = out.reduce((s, f) => s + f.size, 0);
      if (finalTotal > 1 * 1024 * 1024) {
        alert("Total image size must not exceed 1 MB");
        return;
      }

      this.form.images = out;
    },

    getData() {
      this.state = 'loading';

      this.request('GET', 'shop-logs/create', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.types = resp.data.purpose;
        } else alert(resp.message);
      });
    },

    storeLog() {
      const rules = {
        visited_date: 'required',
        images: 'required|min:1|max:5',
        types: 'required|notempty',
      };

      if (!this.validateForm(this.form, rules)) return;

      const formData = new FormData();
      formData.append('visited_date', this.form.visited_date);
      formData.append('purpose', this.form.types);
      formData.append('notes', this.form.notes);

      this.form.images.forEach(file => {
        formData.append('images[]', file);
      });

      this.request('POST', 'shop-logs/create', formData, (resp) => {
        if (resp.success) {
          alert(resp.message);
          this.$router.back();
        } else {
          alert(resp.message);
        }
      });
    }
  },

  created() {
    this.getData();
  },
};
</script>
